import * as React from "react";
// import { pure } from 'recompose'
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
// import * as Lodash  from 'lodash';
// import * as Utils  from '@Cyclope-Utils/index';
import * as i18next from "i18next";
import * as noCache from "shortid";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { item, rediRectToo } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <li className="vcart-incidents" style={{ height: "90%" }}>
      <div className="cart-incident">
        <div className="no-active-camera">
          {Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.CAMERADETAILS,
          ]) &&
            item.liveIncidentUrl &&
            false && (
              <a onClick={rediRectToo} style={{ cursor: "pointer" }}>
                {
                  <div className="image-snapshot  animated fadeIn">
                    {item.connected &&
                      !item.move &&
                      !item.noSignal &&
                      item.snapshot !== "" && (
                        <img
                          className="imageLazyLoad"
                          src={item.snapshot + "?nocache=" + noCache.generate()}
                          alt={item.code}
                        />
                      )}
                    {!item.connected && <div className="impossible" />}
                    {item.connected && item.snapshot === "" && (
                      <div className="impossible" />
                    )}

                    {item.connected && item.move && !item.noSignal && (
                      <div className="came-lg">
                        <div className="BougeCamera" />
                        <img
                          className="imageLazyLoad"
                          src={item.snapshot + "?nocache=" + noCache.generate()}
                          alt={item.code}
                        />
                      </div>
                    )}

                    {item.connected && item.noSignal && (
                      <div className="came-lg">
                        <div className="NoSignalCamera" />
                        <img
                          className="imageLazyLoad"
                          src={item.snapshot + "?nocache=" + noCache.generate()}
                          alt={item.code}
                        />
                      </div>
                    )}
                    <div className="camaraInformationB">
                      {item.connected && item.snapshot === "" && (
                        <p style={{ display: "block" }}>
                          {i18next.t("impossible de charge l image")}
                        </p>
                      )}
                      {!item.connected && (
                        <p style={{ display: "block" }}>
                          {i18next.t("pas de flux video")}
                        </p>
                      )}
                      {item.connected && item.noSignal && (
                        <p style={{ display: "block" }}>
                          {" "}
                          {i18next.t("pas de signal video")}{" "}
                        </p>
                      )}
                      {item.connected && item.move && !item.noSignal && (
                        <p style={{ display: "block" }}>
                          {i18next.t("bouge de camera")}
                        </p>
                      )}
                    </div>
                  </div>
                }
              </a>
            )}
          {Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.CAMERADETAILS,
          ]) && (
            <Link
              to={`${Paths.PathsNamesEnums.CAMERASETTINGID}${item.id}`}
              style={{ cursor: "pointer" }}
            >
              {
                <div className="image-snapshot  animated fadeIn">
                  {item.connected &&
                    !item.move &&
                    !item.noSignal &&
                    item.snapshot !== "" && (
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    )}
                  {!item.connected && <div className="impossible" />}
                  {item.connected && item.snapshot === "" && (
                    <div className="impossible" />
                  )}

                  {item.connected && item.move && !item.noSignal && (
                    <div className="came-lg">
                      <div className="BougeCamera" />
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    </div>
                  )}

                  {item.connected && item.noSignal && (
                    <div className="came-lg">
                      <div className="NoSignalCamera" />
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    </div>
                  )}
                  <div className="camaraInformationB">
                    {item.connected && item.snapshot === "" && (
                      <p style={{ display: "block" }}>
                        {i18next.t("impossible de charge l image")}
                      </p>
                    )}
                    {!item.connected && (
                      <p style={{ display: "block" }}>
                        {i18next.t("pas de flux video")}
                      </p>
                    )}
                    {item.connected && item.noSignal && (
                      <p style={{ display: "block" }}>
                        {" "}
                        {i18next.t("pas de signal video")}{" "}
                      </p>
                    )}
                    {item.connected && item.move && !item.noSignal && (
                      <p style={{ display: "block" }}>
                        {i18next.t("bouge de camera")}
                      </p>
                    )}
                  </div>
                </div>
              }
            </Link>
          )}
          {!Utils.simpleAuthorizationIsAllowed(User, [
            Enums.AuthorizationRightsEnums.CAMERADETAILS,
          ]) && (
            <a>
              {
                <div className="image-snapshot  animated fadeIn">
                  {item.connected &&
                    !item.move &&
                    !item.noSignal &&
                    item.snapshot !== "" && (
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    )}
                  {!item.connected && <div className="impossible" />}
                  {item.connected && item.snapshot === "" && (
                    <div className="impossible" />
                  )}

                  {item.connected && item.move && !item.noSignal && (
                    <div className="came-lg">
                      <div className="BougeCamera" />
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    </div>
                  )}

                  {item.connected && item.noSignal && (
                    <div className="came-lg">
                      <div className="NoSignalCamera" />
                      <img
                        className="imageLazyLoad"
                        src={item.snapshot + "?nocache=" + noCache.generate()}
                        alt={item.code}
                      />
                    </div>
                  )}
                  <div className="camaraInformationB">
                    {item.connected && item.snapshot === "" && (
                      <p style={{ display: "block" }}>
                        {i18next.t("impossible de charge l image")}
                      </p>
                    )}
                    {!item.connected && (
                      <p style={{ display: "block" }}>
                        {i18next.t("pas de flux video")}
                      </p>
                    )}
                    {item.connected && item.noSignal && (
                      <p style={{ display: "block" }}>
                        {" "}
                        {i18next.t("pas de signal video")}{" "}
                      </p>
                    )}
                    {item.connected && item.move && !item.noSignal && (
                      <p style={{ display: "block" }}>
                        {i18next.t("bouge de camera")}
                      </p>
                    )}
                  </div>
                </div>
              }
            </a>
          )}
          <div className="image-snapshot-footer-infos">
            <span>
              {i18next.t("cam")} {item.code}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  rediRectToo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/camera/component.tsx